import { FormField, InputField, SwitchField } from "common";
import { isEmpty } from "lodash";
import React from "react";

interface InfoFieldProps {
    isDisabled: boolean;
    name: string;
    label: string;
    value?: string;
    isRequired: boolean | null;
    className?: string;
    onToggleRequired: (value: boolean) => void;
    onChange?: (value: string) => void;
}

export const InfoField = ({
    isDisabled,
    name,
    label,
    value,
    isRequired,
    className,
    onToggleRequired,
    onChange,
}: InfoFieldProps) => {
    const disabledInputField = isRequired === null ? isDisabled : !isRequired || isDisabled;

    return (
        <FormField
            preventLabelClick
            name={name}
            label={
                isRequired === null || isDisabled ? (
                    label
                ) : (
                    <SwitchField
                        size="small"
                        direction="left"
                        isChecked={isRequired}
                        labelClassName="font-bold"
                        onChange={onToggleRequired}
                    >
                        {label}
                    </SwitchField>
                )
            }
        >
            <InputField
                isRequired={isRequired ?? true}
                type="text"
                className={className}
                name={name}
                placeholder={isEmpty(value) ? label : value}
                disabled={disabledInputField}
                onChange={onChange}
            />
        </FormField>
    );
};
